var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container pt-2"},[_c('PageTitle',{attrs:{"main":"Clientes","sub":"Cadastrar, alterar ou deletar Clientes"}}),_vm._v(" testando "),_c('font-awesome-icon',{attrs:{"icon":['fa', 'user-secret']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }